import {
  BannerCommonContentsOptionType,
  BannerCreateInitValuesType,
} from "@pages/BannerCreate/Data";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { CommonCreateBodyKeyType, CommonDataType } from "src/types/common";

export interface BannerDetailInitValuesType extends BannerCreateInitValuesType {
  contentPostStartDate?: string | null;
  contentPostEndDate?: string | null;
}

export const BannerDetailData: CommonDataType<
  CommonCreateBodyKeyType,
  BannerDetailInitValuesType,
  BannerCommonContentsOptionType
> = {
  createBodyKey: [
    "category",
    "postStartAt",
    "postEndAt",
    "isExposed",
    "title",
    "thumbnail",
    "contentCategory",
    "contentId",
    "id",
    "url",
    "displayOrder",
    "bannerExposureLocation",
  ],
  formInitialValues: {
    category: "popup",
    postStartAt: "",
    postEndAt: "",
    isExposed: false,
    title: "",
    thumbnail: "",
    contentCategory: "notice",
    contentId: null,
    url: "",
    displayOrder: 0,
    bannerExposureLocation: [],
  },
  contentsOption: [
    {
      label: "배너종류",
      name: "category",
      type: CommonElementType.RADIO,
      options: [
        { label: "토스트 팝업", value: "popup" },
        { label: "띠 배너", value: "banner" },
      ],
    },
    {
      label: "분류",
      name: "bannerExposureLocation",
      type: CommonElementType.CHECK_BOX,
      hasKeywordToShowContent: "banner",
      options: [
        {
          label: "전체",
          value: "ENTIRE",
        },
        {
          label: "홈",
          value: "HOME",
        },
        {
          label: "포인트 충전하기",
          value: "PREPAID",
        },
        {
          label: "충전권 선물하기",
          value: "GIFT",
        },
        {
          label: "토크ON",
          value: "TALK_ON",
        },
      ],
    },
    {
      label: "게시 기간",
      name: "postStartAt",
      secondName: "postEndAt",
      type: CommonElementType.DATE_RANGE_PICKER,
      placeholder: "날짜를 입력해주세요",
      secondPlaceholder: "날짜를 입력해주세요",
    },
    {
      label: "노출 상태",
      name: "isExposed",
      type: CommonElementType.TOGGLE,
    },
    {
      label: "제목(관리자용)",
      name: "title",
      type: CommonElementType.INPUT,
      placeholder: "팝업 제목을 입력해주세요",
    },
    {
      label: "팝업 이미지",
      name: "thumbnail",
      type: CommonElementType.IMAGE_UPLOAD,
      size: "large",
      isSizeQuestion: true,
    },
  ],
};
